import {createContext, useContext, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useAuth} from "@/context/AuthContext";
import {api} from "@/lib/api";
import {resolveCustomerTag} from "@/customerTags";

const Context=createContext({});
export function CustomerTagProvider({children}) {
  const {user}=useAuth();
  const scope=`${user?.id || ''}:${user?.studio_id || ''}:${user?.role || ''}`;
  const [state,setState]=useState({scope:'',tags:{}});
  useEffect(()=>{
    let active=true,version=0,timer;
    if(!['studio_owner','manager','front_desk','artist'].includes(user?.role)) return;
    const load=async()=>{const request=++version;try{const tags=await api.get('/customer-tags');if(active&&request===version)setState({scope,tags});}catch{if(active&&request===version)setState({scope,tags:{}});}};
    const refresh=()=>{clearTimeout(timer);timer=setTimeout(load,200);};
    load();window.addEventListener('tps:data-changed',refresh);window.addEventListener('focus',refresh);
    return()=>{active=false;clearTimeout(timer);window.removeEventListener('tps:data-changed',refresh);window.removeEventListener('focus',refresh);};
  },[scope]); // eslint-disable-line react-hooks/exhaustive-deps
  return <Context.Provider value={state.scope===scope?state.tags:{}}>{children}</Context.Provider>;
}
export const useCustomerTags=()=>useContext(Context);

export default function CustomerTag({customerId,customer,artists=[],tag}) {
  const tags=useCustomerTags();const {t}=useTranslation();
  const identity=tag || resolveCustomerTag(customer || {id:customerId},artists,tags);
  if(!customerId&&!customer?.id&&!customer?.ownership_type&&!tag)return null;
  const label=identity.kind==='studio'?t('customerTag.studio'):identity.kind==='artist'?t('customerTag.artist',{name:identity.owner_name || t('customerTag.professional')}):t('customerTag.unknown');
  return <span role="img" aria-label={label} title={label} data-customer-tag={identity.kind} className="mr-2 inline-block h-2.5 w-2.5 shrink-0 rounded-full align-middle ring-1 ring-black/20" style={{backgroundColor:identity.color}}/>;
}
